import React from 'react';
import PublicHeader from '../PublicHeader';
import PublicFooter from '../PublicFooter';

function getInitialLang() {
    try { return localStorage.getItem('publicLang') || 'bs'; } catch (e) { return 'bs'; }
}

const LAST_UPDATED = { bs: '11. august 2026.', en: 'August 11, 2026' };

const content = {
    bs: {
        docTitle: 'Politika privatnosti',
        nav: {
            home: 'Početna', mobile: 'Mobilna aplikacija', privacy: 'Privatnost', login: 'Prijava'
        },
        intro: 'Ova Politika privatnosti odnosi se na Jedinstveni informacioni sistem eUNSA u cjelini — web aplikaciju na eunsa.ba, mobilne aplikacije eUNSA za Android i iOS te pripadajuće pozadinske servise. Primjenjuje se jednako bez obzira na to pristupate li sistemu putem web browsera ili mobilne aplikacije.',
        back: '← Nazad na početnu',
        lastUpdated: 'Posljednje ažuriranje',
        sections: [
            {
                title: '1. Ko obrađuje vaše podatke',
                body: [
                    'Kontrolor ličnih podataka je Univerzitet u Sarajevu, kao i organizacione jedinice (fakulteti i akademije) u dijelu evidencija koje same vode.',
                    {
                        list: [
                            'Kontakt: eunsa@unsa.ba · +387 33 560 240 · https://www.utic.unsa.ba',
                            'Tehničko održavanje sistema: Univerzitetski tele-informatički centar (UTIC), u svojstvu obrađivača'
                        ]
                    },
                    'Obrada se vrši u skladu sa Zakonom o zaštiti ličnih podataka BiH („Službeni glasnik BiH“ br. 49/06, 76/11, 89/11) i propisima iz oblasti visokog obrazovanja.'
                ]
            },
            {
                title: '2. Koje podatke prikupljamo',
                body: [
                    { sub: '2.1. Osnovni lični podaci (svi subjekti evidentirani u sistemu)' },
                    {
                        list: [
                            'ime, prezime, djevojačko prezime',
                            'spol',
                            'JMBG',
                            'datum i mjesto rođenja',
                            'državljanstvo (jedno ili više) i nacionalnost',
                            'adresa prebivališta i adresa trenutnog boravišta (ulica, mjesto)',
                            'kontakt podaci — e-mail adresa, broj telefona i drugi tipovi kontakta predviđeni šifrarnikom',
                            'fotografija (ako je pohranjena uz profil)',
                            'podaci o roditeljima — ime i prezime oca i majke, a po potrebi i njihov radni status i zanimanje',
                            'podaci o prethodnom obrazovanju — ustanova, nivo obrazovanja, godina završetka, prosječna ocjena, broj svjedodžbe/diplome',
                            'službene napomene i komentari koje unosi ovlašteno osoblje',
                            'oznaka saglasnosti za kontaktiranje'
                        ]
                    },
                    'Nisu sva navedena polja obavezna. Obavezni su samo podaci bez kojih se evidencija ne može voditi, dok polja označena kao neobavezna u sistemu možete ostaviti prazna bez posljedica po vaš status.',

                    { sub: '2.2. Podaci o studentima' },
                    {
                        list: [
                            'studijski program, ciklus, godina i semestar studija, datum upisa',
                            'statusi studenta, pauze u studiju, promjene fakulteta i studijskog programa',
                            'prijave ispita, ocjene, položeni i nepoloženi predmeti, priznavanja ispita i ekvivalencije',
                            'pripadnost studentskim grupama i grupama izvođenja nastave',
                            'broj indeksa i drugi identifikacioni dokumenti studenta',
                            'način i izvor finansiranja studija, dugovanja, stipendije i iznosi stipendija',
                            'podaci o mobilnosti (Erasmus+, CEEPUS i drugi programi), praksi i internshipu',
                            'završni/diplomski/magistarski/doktorski rad, komisije, odbrane i ocjene odbrane',
                            'disciplinski postupci i izrečene mjere',
                            'izdati dokumenti i uvjerenja (uključujući generisane PDF dokumente koji se pohranjuju u sistemu), broj diplome i datum promocije'
                        ]
                    },
                    'Ovi podaci nastaju postepeno, kako teče studij i velik dio njih postoji samo ako je do određenog događaja stvarno došlo — pauza u studiju, ispis, promjena fakulteta, disciplinski postupak, stipendija ili odlazak na mobilnost. Napomene i komentari koje unosi relevantno osoblje nisu obavezni.',

                    { sub: '2.3. Podaci o zaposlenicima i angažovanom osoblju' },
                    {
                        list: [
                            'podaci o zaposlenju: ugovori (broj, vrsta, trajanje, radno vrijeme), radni staž, prekidi ugovora i razlozi prestanka',
                            'akademska zvanja',
                            'periodi PIO/MIO osiguranja',
                            'nastavno opterećenje, angažman na predmetima, sistematizacija i radna mjesta',
                            'članstva u komisijama i mentorstva'
                        ]
                    },
                    'Obavezni su podaci koji proizlaze iz ugovora o radu i propisa o evidencijama u oblasti rada.',

                    { sub: '2.4. Podaci o eksternim (dolaznim) studentima na mobilnosti' },
                    'Prikupljaju se putem javnog registracionog linka (bez prijave na sistem): ime i prezime, e-mail, identifikacioni broj, spol, datum i mjesto rođenja, država rođenja i državljanstva, Evropski studentski identifikator (ESI), nivo poznavanja engleskog jezika i drugih jezika, iznos stipendije, podaci o matičnoj instituciji (naziv, fakultet, odsjek, Erasmus kod, država, adresa) i podaci o kontakt osobi matične institucije (ime, prezime, e-mail, telefon).',
                    'Na registracionoj formi obavezni su: ime i prezime, e-mail, identifikacioni broj, spol, datum i mjesto rođenja, država rođenja i državljanstva, nivo poznavanja engleskog jezika, podaci o programu mobilnosti, naziv i država matične institucije te ime, prezime i e-mail kontakt osobe. Neobavezni su: Evropski studentski identifikator (ESI), iznos stipendije, ostali jezici, naziv odsjeka i Erasmus kod matične institucije, njena adresa i telefon kontakt osobe.',

                    { sub: '2.5. Posebno osjetljive kategorije podataka' },
                    'Sistem omogućava evidentiranje i podataka koji zahtijevaju povišen nivo zaštite. Ovi podaci većinom nisu obavezni — evidentiraju se samo ako ih sami dostavite ili ako postoji izričita zakonska obaveza, i pohranjuju se odvojeno, tako da za većinu lica u sistemu uopšte ne postoje:',
                    {
                        table: {
                            head: ['Podatak', 'Obaveznost', 'Osnov i svrha'],
                            rows: [
                                ['Podaci o invaliditetu (uz napomenu)', 'dobrovoljno', 'dostavljate ih samo ako želite ostvariti prava na prilagođavanje studija/rada; nedavanje ne utiče na status'],
                                ['Socijalni status (kategorija iz šifrarnika, uz napomenu)', 'dobrovoljno', 'dokazivanje prava na oslobađanje od naknada, stipendije i slične olakšice'],
                                ['Nacionalnost', 'dobrovoljno', 'statistička izvještavanja; možete ostaviti neizjašnjeno'],
                                ['Državljanstvo', 'obavezno', 'utvrđivanje statusa i uslova studiranja/zaposlenja propisanih zakonom']
                            ]
                        }
                    },
                    'Ako dobrovoljni podatak ne date, to nema nikakvih posljedica po vaš status studenta ili zaposlenika. Već dat podatak možete u svakom trenutku zatražiti da se izbriše. Pristup ovim podacima ima samo uži krug ovlaštenih lica i ne koriste se ni u koju drugu svrhu.',

                    { sub: '2.6. Tehnički podaci i podaci o korištenju sistema' },
                    {
                        list: [
                            'korisničko ime i dodijeljene uloge u sistemu (upravljanje pristupom putem Keycloak SSO servisa)',
                            'revizijski trag izmjena: za svaku izmjenu podataka bilježi se ko je izmjenu izvršio, kada i sa koje IP adrese',
                            'evidencija poslanih e-mail poruka: pošiljalac, primalac, naslov, sadržaj poruke, status slanja i eventualna greška',
                            'evidencija obavijesti u sistemu (kada je obavijest pročitana)',
                            'evidencija pristupa anketama'
                        ]
                    },
                    'Ove podatke ne unosite vi — sistem ih bilježi automatski tokom rada i oni se ne mogu isključiti jer su obavezni za sigurnost i sljedivost izmjena.',
                    'Sistem ne koristi alate za web analitiku, mjerenje posjećenosti, oglašavanje niti profilisanje korisnika (npr. Google Analytics, Meta Pixel, Hotjar i slično).'
                ]
            },
            {
                title: '3. Odakle dobijamo podatke',
                body: [
                    {
                        list: [
                            'direktno od vas — prilikom upisa, prijave na konkurs, zasnivanja radnog odnosa, registracije na mobilnost ili ažuriranja ličnih podataka',
                            'od ovlaštenog osoblja organizacionih jedinica koje vodi službene evidencije',
                            'iz ranijih/naslijeđenih evidencija Univerziteta koje su migrirane u sistem',
                            'od institucija koje vas upućuju (matične institucije studenata na mobilnosti)'
                        ]
                    }
                ]
            },
            {
                title: '4. Svrhe i pravni osnov obrade',
                body: [
                    {
                        table: {
                            head: ['Svrha', 'Pravni osnov'],
                            rows: [
                                ['Vođenje matične evidencije studenata, upis, praćenje toka i završetka studija', 'zakonska obaveza i obavljanje poslova od javnog interesa'],
                                ['Izdavanje uvjerenja, diploma, dodataka diplomi i drugih javnih isprava', 'zakonska obaveza'],
                                ['Organizacija nastave, ispita i ocjenjivanja', 'izvršenje ugovora o studiranju / javni interes'],
                                ['Vođenje kadrovske evidencije i evidencije o radu', 'zakonska obaveza (radno i penziono zakonodavstvo)'],
                                ['Naplata školarine, evidencija stipendija i finansiranja', 'ugovor i zakonska obaveza'],
                                ['Izvještavanje nadležnim organima i statistika u oblasti visokog obrazovanja', 'zakonska obaveza'],
                                ['Osiguranje kvaliteta (studentske ankete o nastavi)', 'javni interes'],
                                ['Programi međunarodne mobilnosti', 'ugovor i javni interes'],
                                ['Slanje obavijesti vezanih za studij/rad putem e-maila i aplikacije', 'javni interes / izvršenje ugovora'],
                                ['Kontaktiranje u svrhe koje nisu nužne za studij (npr. informativne poruke)', 'saglasnost (evidentira se u sistemu i može se povući)'],
                                ['Informaciona sigurnost, revizijski trag i sprječavanje zloupotreba', 'legitimni interes / zakonska obaveza']
                            ]
                        }
                    }
                ]
            },
            {
                title: '5. Kolačići i podaci pohranjeni u vašem uređaju',
                body: [
                    'eUNSA ne postavlja marketinške ni analitičke kolačiće. Koriste se samo tehnički nužni kolačići i lokalna pohrana u browseru.',

                    { sub: '5.1. Obavezni kolačići' },
                    {
                        table: {
                            head: ['Kolačić', 'Postavlja', 'Svrha', 'Trajanje'],
                            rows: [
                                ['AUTH_SESSION_ID, KEYCLOAK_IDENTITY, KEYCLOAK_SESSION, KC_RESTART (i srodni)', 'Keycloak servis za prijavu (/auth)', 'održavanje prijavljene sesije i jedinstvene prijave (SSO)', 'do isteka sesije, odnosno prema konfiguraciji Keycloak realma'],
                                ['XSRF-TOKEN', 'aplikacija', 'zaštita od CSRF napada pri komunikaciji sa serverom', 'sesija']
                            ]
                        }
                    },
                    'Ovi kolačići su neophodni za rad aplikacije — bez njih prijava i korištenje sistema nisu mogući, pa se za njih ne traži posebna saglasnost.',

                    { sub: '5.2. Lokalna pohrana (localStorage / sessionStorage)' },
                    'Aplikacija u memoriji vašeg browsera privremeno pohranjuje radne podatke radi funkcionalnosti, između ostalog:',
                    {
                        list: [
                            'aktivnu ulogu i odabrani korisnički profil (activeRole, u, lastSelectedU),',
                            'postavke filtera, odabranih kartica i pregleda,',
                            'radne kopije podataka o entitetu koji se trenutno obrađuje (npr. podaci o odabranom studentu, osobi ili zaposleniku tokom unosa).'
                        ]
                    },
                    'Ovi podaci ostaju na vašem uređaju i brišu se odjavom, brisanjem podataka browsera ili napuštanjem stranice, a nakon rada je obavezna odjava.',

                    { sub: '5.3. Pristupni tokeni' },
                    'Za autentifikaciju se koriste OAuth2/OpenID Connect tokeni koje izdaje Keycloak; oni se drže u memoriji aplikacije tokom trajanja sesije.'
                ]
            },
            {
                title: '6. Kome se podaci dostavljaju',
                body: [
                    'Podaci se dostavljaju samo onima koji na njih imaju pravni osnov:',
                    {
                        list: [
                            'organizacionim jedinicama Univerziteta (fakultetima i akademijama) — u obimu potrebnom za vođenje njihovih evidencija; sistem primjenjuje kontrolu pristupa po ulogama i pripadnosti organizacionoj jedinici',
                            'nadležnom ministarstvu za odgoj i obrazovanje — u obimu propisanog izvještavanja (u sistemu postoji zasebna uloga s ograničenim, pretežno statističkim pristupom)',
                            'Službi za zapošljavanje Kantona Sarajevo — u obimu predviđenom propisima i sporazumom',
                            'službama za osiguranje kvaliteta — rezultati anketa i izvještaji',
                            'partnerskim institucijama u programima mobilnosti — podaci o studentima na razmjeni',
                            'pružaocu usluge e-mail servisa — pri slanju obavijesti sistem koristi vanjski SMTP servis (smtp.gmail.com, Google), koji obrađuje adresu primaoca i sadržaj poruke',
                            'vlastitoj službi za informacione tehnologije i izvođačima na održavanju sistema (UTIC) — pristup imaju samo radi rada, održavanja i sigurnosnih kopija sistema, na osnovu ugovora o obradi podataka; podaci se ne koriste ni u koju drugu svrhu',
                            'nadležnim organima kada je to propisano zakonom'
                        ]
                    },
                    'Podaci se ne prodaju niti ustupaju u marketinške svrhe.'
                ]
            },
            {
                title: '7. Koliko dugo čuvamo podatke',
                body: [
                    {
                        table: {
                            head: ['Kategorija', 'Rok čuvanja'],
                            rows: [
                                ['Matična evidencija studenata, evidencija o izdatim diplomama i uvjerenjima', 'trajno, u skladu s propisima o evidencijama u visokom obrazovanju'],
                                ['Kadrovska evidencija i ugovori o radu', 'u skladu s radnim i penzionim propisima'],
                                ['Podaci o eksternim studentima na mobilnosti', 'za vrijeme trajanja mobilnosti i nakon završetka'],
                                ['Odgovori na ankete i statistike osiguranja kvaliteta', 'trajno, u skladu s odredbama relevantnog pravilnika'],
                                ['Revizijski trag izmjena (korisnik, vrijeme, IP adresa)', 'trajno']
                            ]
                        }
                    }
                ]
            },
            {
                title: '8. Sigurnost podataka',
                body: [
                    {
                        list: [
                            'prijava putem centralnog sistema (Keycloak) uz OAuth2/OpenID Connect tokene',
                            'pristup podacima ograničen ulogama i pripadnošću organizacionoj jedinici — korisnik vidi samo podatke koji su mu potrebni za rad',
                            'komunikacija između browsera i servera zaštićena je HTTPS protokolom',
                            'automatski revizijski trag svih izmjena ključnih podataka (ko, kada, s koje IP adrese)',
                            'redovne sigurnosne kopije i kontrola pristupa bazi podataka'
                        ]
                    },
                    'Ako i pored primijenjenih mjera dođe do povrede sigurnosti ličnih podataka, postupit ćemo u skladu sa zakonom i obavijestiti nadležne organe i pogođena lica kada je to propisano.'
                ]
            },
            {
                title: '9. Vaša prava',
                body: [
                    'Imate pravo da:',
                    {
                        list: [
                            'dobijete informaciju obrađuju li se vaši podaci i pristupite im,',
                            'zatražite ispravku netačnih ili dopunu nepotpunih podataka,',
                            'zatražite brisanje podataka kada za njihovu obradu više ne postoji pravni osnov (ovo pravo ne obuhvata podatke koje smo dužni trajno čuvati po zakonu),',
                            'zatražite ograničenje obrade ili uložite prigovor na obradu,',
                            'povučete saglasnost u svakom trenutku, kada je obrada zasnovana na saglasnosti — povlačenje ne utiče na zakonitost ranije obrade,',
                            'podnesete pritužbu Agenciji za zaštitu ličnih podataka u Bosni i Hercegovini.'
                        ]
                    },
                    'Zahtjev podnosite na eunsa@unsa.ba. Odgovor dostavljamo u zakonskom roku, a radi zaštite vaših podataka možemo zatražiti dodatnu potvrdu identiteta.'
                ]
            },
            {
                title: '10. Automatizovano odlučivanje',
                body: [
                    'Sistem ne donosi odluke isključivo automatizovanom obradom koje bi proizvodile pravne posljedice po vas i ne vrši profilisanje korisnika. Izračuni koje sistem provodi (npr. prosjek ocjena, ostvareni ECTS bodovi, ispunjenost uslova za upis naredne godine) služe kao podrška odlučivanju ovlaštenog osoblja.'
                ]
            },
            {
                title: '11. Izmjene ove politike',
                body: [
                    'Politiku možemo mijenjati radi usklađivanja s propisima ili promjenama u sistemu. Aktuelna verzija uvijek je dostupna u aplikaciji, uz naznaku datuma posljednje izmjene. O značajnim izmjenama korisnici će biti obaviješteni putem sistema.'
                ]
            },
            {
                title: '12. Kontakt',
                body: [
                    'Univerzitet u Sarajevu — Univerzitetski tele-informatički centar (UTIC)',
                    'E-mail: eunsa@unsa.ba · Telefon: +387 33 560 240 · Web: https://www.utic.unsa.ba'
                ]
            }
        ]
    },
    en: {
        docTitle: 'Privacy Policy',
        nav: {
            home: 'Home', mobile: 'Mobile app', privacy: 'Privacy', login: 'Sign in'
        },
        intro: 'This Privacy Policy applies to the eUNSA Unified Information System as a whole — the web application at eunsa.ba, the eUNSA mobile applications for Android and iOS, and the supporting backend services. It applies equally whether you access the system through a web browser or the mobile application.',
        back: '← Back to home',
        lastUpdated: 'Last updated',
        sections: [
            {
                title: '1. Who processes your data',
                body: [
                    'The controller of personal data is the University of Sarajevo, together with its organizational units (faculties and academies) for the records they keep themselves.',
                    {
                        list: [
                            'Contact: eunsa@unsa.ba · +387 33 560 240 · https://www.utic.unsa.ba',
                            'Technical maintenance of the system: University Tele-Information Center (UTIC), acting as processor'
                        ]
                    },
                    'Processing is carried out in accordance with the Law on Personal Data Protection of Bosnia and Herzegovina (Official Gazette of BiH no. 49/06, 76/11, 89/11) and with higher education regulations.'
                ]
            },
            {
                title: '2. What data we collect',
                body: [
                    { sub: '2.1. Basic personal data (all individuals recorded in the system)' },
                    {
                        list: [
                            'first name, last name, maiden name',
                            'gender',
                            'personal identification number (JMBG)',
                            'date and place of birth',
                            'citizenship (one or more) and ethnicity',
                            'address of permanent and current residence (street, place)',
                            'contact details — email address, phone number and other contact types defined in the code list',
                            'photograph (if stored with the profile)',
                            'parents’ data — first and last name of father and mother and, where relevant, their employment status and occupation',
                            'previous education — institution, level of education, year of completion, average grade, certificate/diploma number',
                            'official notes and comments entered by authorized staff',
                            'consent flag for being contacted'
                        ]
                    },
                    'Not all of the listed fields are mandatory. Only data without which the records cannot be kept is required, while fields marked as optional in the system may be left blank with no consequences for your status.',

                    { sub: '2.2. Student data' },
                    {
                        list: [
                            'study program, cycle, year and semester of study, enrollment date',
                            'student statuses, study pauses, changes of faculty and study program',
                            'exam registrations, grades, passed and failed courses, exam recognitions and equivalences',
                            'membership in student groups and teaching groups',
                            'student ID number and other student identification documents',
                            'method and source of study financing, debts, scholarships and scholarship amounts',
                            'mobility data (Erasmus+, CEEPUS and other programs), placements and internships',
                            'final/graduate/master’s/doctoral thesis, committees, defenses and defense grades',
                            'disciplinary proceedings and measures imposed',
                            'issued documents and certificates (including generated PDF documents stored in the system), diploma number and promotion date'
                        ]
                    },
                    'This data accumulates gradually as your studies progress, and much of it exists only if a particular event actually occurred — a study pause, withdrawal, change of faculty, disciplinary proceeding, scholarship or mobility. Notes and comments entered by the relevant staff are not mandatory.',

                    { sub: '2.3. Data on employees and engaged staff' },
                    {
                        list: [
                            'employment data: contracts (number, type, duration, working hours), length of service, contract interruptions and reasons for termination',
                            'academic titles',
                            'pension and disability insurance (PIO/MIO) periods',
                            'teaching workload, course engagement, job classification and positions',
                            'membership in committees and mentorships'
                        ]
                    },
                    'Mandatory data is that arising from the employment contract and from regulations on employment records.',

                    { sub: '2.4. Data on external (incoming) mobility students' },
                    'Collected through a public registration link (without signing in to the system): first and last name, email, identification number, gender, date and place of birth, country of birth and citizenship, European Student Identifier (ESI), level of English and other languages, scholarship amount, home institution details (name, faculty, department, Erasmus code, country, address) and contact person details at the home institution (first name, last name, email, phone).',
                    'The following are mandatory on the registration form: first and last name, email, identification number, gender, date and place of birth, country of birth and citizenship, level of English, mobility program details, name and country of the home institution, and the contact person’s first name, last name and email. The following are optional: European Student Identifier (ESI), scholarship amount, other languages, department name and Erasmus code of the home institution, its address, and the contact person’s phone number.',

                    { sub: '2.5. Special categories of sensitive data' },
                    'The system also allows recording of data that requires a higher level of protection. This data is mostly not mandatory — it is recorded only if you provide it yourself or if there is an explicit legal obligation, and it is stored separately, so for most individuals in the system it does not exist at all:',
                    {
                        table: {
                            head: ['Data', 'Requirement', 'Basis and purpose'],
                            rows: [
                                ['Disability data (with a note)', 'voluntary', 'provided only if you wish to exercise rights to adjustments in study or work; not providing it does not affect your status'],
                                ['Social status (category from the code list, with a note)', 'voluntary', 'evidence of entitlement to fee exemptions, scholarships and similar benefits'],
                                ['Ethnicity', 'voluntary', 'statistical reporting; may be left undeclared'],
                                ['Citizenship', 'mandatory', 'determining status and the conditions of study or employment prescribed by law']
                            ]
                        }
                    },
                    'If you choose not to provide voluntary data, this has no consequences for your status as a student or employee. Data already provided may be deleted at your request at any time. Only a narrow circle of authorized persons has access to this data, and it is not used for any other purpose.',

                    { sub: '2.6. Technical data and system usage data' },
                    {
                        list: [
                            'username and roles assigned in the system (access management via the Keycloak SSO service)',
                            'audit trail of changes: for every change to data, the system records who made it, when, and from which IP address',
                            'log of sent email messages: sender, recipient, subject, message content, delivery status and any error',
                            'record of in-system notifications (when a notification was read)',
                            'record of access to surveys'
                        ]
                    },
                    'You do not enter this data — the system records it automatically during operation, and it cannot be switched off because it is required for security and traceability of changes.',
                    'The system does not use web analytics, traffic measurement, advertising or user profiling tools (such as Google Analytics, Meta Pixel, Hotjar and similar).'
                ]
            },
            {
                title: '3. Where we obtain data from',
                body: [
                    {
                        list: [
                            'directly from you — at enrollment, when applying to a competition, on entering employment, when registering for mobility, or when updating your personal data',
                            'from authorized staff of organizational units that maintain official records',
                            'from earlier/legacy University records migrated into the system',
                            'from institutions that send you (home institutions of mobility students)'
                        ]
                    }
                ]
            },
            {
                title: '4. Purposes and legal basis of processing',
                body: [
                    {
                        table: {
                            head: ['Purpose', 'Legal basis'],
                            rows: [
                                ['Keeping the central student records, enrollment, tracking the course and completion of studies', 'legal obligation and performance of tasks in the public interest'],
                                ['Issuing certificates, diplomas, diploma supplements and other public documents', 'legal obligation'],
                                ['Organization of teaching, examinations and grading', 'performance of the study agreement / public interest'],
                                ['Keeping personnel and employment records', 'legal obligation (labour and pension legislation)'],
                                ['Collection of tuition fees, records of scholarships and financing', 'contract and legal obligation'],
                                ['Reporting to competent authorities and higher education statistics', 'legal obligation'],
                                ['Quality assurance (student surveys on teaching)', 'public interest'],
                                ['International mobility programs', 'contract and public interest'],
                                ['Sending study- and work-related notifications by email and in the application', 'public interest / performance of the agreement'],
                                ['Contacting you for purposes not necessary for your studies (e.g. informational messages)', 'consent (recorded in the system and revocable)'],
                                ['Information security, audit trail and prevention of misuse', 'legitimate interest / legal obligation']
                            ]
                        }
                    }
                ]
            },
            {
                title: '5. Cookies and data stored on your device',
                body: [
                    'eUNSA does not set marketing or analytics cookies. Only strictly necessary cookies and browser local storage are used.',

                    { sub: '5.1. Strictly necessary cookies' },
                    {
                        table: {
                            head: ['Cookie', 'Set by', 'Purpose', 'Duration'],
                            rows: [
                                ['AUTH_SESSION_ID, KEYCLOAK_IDENTITY, KEYCLOAK_SESSION, KC_RESTART (and related)', 'Keycloak sign-in service (/auth)', 'maintaining the signed-in session and single sign-on (SSO)', 'until the session expires, according to the Keycloak realm configuration'],
                                ['XSRF-TOKEN', 'the application', 'protection against CSRF attacks in communication with the server', 'session']
                            ]
                        }
                    },
                    'These cookies are essential for the application to work — without them signing in and using the system is not possible, so no separate consent is requested for them.',

                    { sub: '5.2. Local storage (localStorage / sessionStorage)' },
                    'The application temporarily stores working data in your browser for functionality, including:',
                    {
                        list: [
                            'the active role and the selected user profile (activeRole, u, lastSelectedU),',
                            'filter, tab and view settings,',
                            'working copies of the record currently being edited (e.g. data on the selected student, person or employee during entry).'
                        ]
                    },
                    'This data stays on your device and is cleared on sign-out, when you clear your browser data, or when you leave the page; signing out after work is mandatory.',

                    { sub: '5.3. Access tokens' },
                    'Authentication uses OAuth2/OpenID Connect tokens issued by Keycloak; they are held in the application’s memory for the duration of the session.'
                ]
            },
            {
                title: '6. Who we share data with',
                body: [
                    'Data is disclosed only to those who have a legal basis for it:',
                    {
                        list: [
                            'organizational units of the University (faculties and academies) — to the extent needed to maintain their records; the system applies access control by role and by organizational unit',
                            'the competent ministry of education — to the extent of prescribed reporting (the system has a separate role with limited, mainly statistical access)',
                            'the Sarajevo Canton Employment Service — to the extent provided for by regulations and agreement',
                            'quality assurance services — survey results and reports',
                            'partner institutions in mobility programs — data on exchange students',
                            'the email service provider — when sending notifications the system uses an external SMTP service (smtp.gmail.com, Google), which processes the recipient’s address and the message content',
                            'our own IT service and contractors maintaining the system (UTIC) — access is granted solely for operation, maintenance and backups of the system, under a data processing agreement; the data is not used for any other purpose',
                            'competent authorities where required by law'
                        ]
                    },
                    'Data is not sold or shared for marketing purposes.'
                ]
            },
            {
                title: '7. How long we keep data',
                body: [
                    {
                        table: {
                            head: ['Category', 'Retention period'],
                            rows: [
                                ['Central student records, records of issued diplomas and certificates', 'permanently, in accordance with regulations on higher education records'],
                                ['Personnel records and employment contracts', 'in accordance with labour and pension regulations'],
                                ['Data on external mobility students', 'for the duration of the mobility and after its completion'],
                                ['Survey responses and quality assurance statistics', 'permanently, in accordance with the provisions of the relevant rulebook'],
                                ['Audit trail of changes (user, time, IP address)', 'permanently']
                            ]
                        }
                    }
                ]
            },
            {
                title: '8. Data security',
                body: [
                    {
                        list: [
                            'sign-in through the central system (Keycloak) using OAuth2/OpenID Connect tokens',
                            'access to data limited by role and organizational unit — a user sees only the data needed for their work',
                            'communication between the browser and the server is protected by HTTPS',
                            'an automatic audit trail of all changes to key data (who, when, from which IP address)',
                            'regular backups and controlled access to the database'
                        ]
                    },
                    'If, despite the measures applied, a personal data breach occurs, we will act in accordance with the law and notify the competent authorities and affected individuals where required.'
                ]
            },
            {
                title: '9. Your rights',
                body: [
                    'You have the right to:',
                    {
                        list: [
                            'be informed whether your data is being processed and to access it,',
                            'request rectification of inaccurate data or completion of incomplete data,',
                            'request erasure of data where there is no longer a legal basis for processing it (this right does not cover data we are required by law to keep permanently),',
                            'request restriction of processing or object to processing,',
                            'withdraw your consent at any time where processing is based on consent — withdrawal does not affect the lawfulness of earlier processing,',
                            'lodge a complaint with the Personal Data Protection Agency of Bosnia and Herzegovina.'
                        ]
                    },
                    'Requests are submitted to eunsa@unsa.ba. We respond within the statutory deadline and, in order to protect your data, we may ask for additional confirmation of your identity.'
                ]
            },
            {
                title: '10. Automated decision-making',
                body: [
                    'The system does not make decisions based solely on automated processing that would produce legal effects concerning you, and it does not profile users. Calculations performed by the system (e.g. grade average, ECTS credits earned, eligibility for enrollment into the next year) serve as support for decisions made by authorized staff.'
                ]
            },
            {
                title: '11. Changes to this policy',
                body: [
                    'We may amend this policy to align it with regulations or with changes in the system. The current version is always available in the application, with the date of the last change indicated. Users will be notified of significant changes through the system.'
                ]
            },
            {
                title: '12. Contact',
                body: [
                    'University of Sarajevo — University Tele-Information Center (UTIC)',
                    'Email: eunsa@unsa.ba · Phone: +387 33 560 240 · Web: https://www.utic.unsa.ba'
                ]
            }
        ]
    }
};

function Block({ item }) {
    if (typeof item === 'string') {
        return <p>{item}</p>;
    }
    if (item.sub) {
        return <h3>{item.sub}</h3>;
    }
    if (item.list) {
        return (
            <ul>
                {item.list.map((li, i) => <li key={i}>{li}</li>)}
            </ul>
        );
    }
    if (item.table) {
        return (
            <div className="table-wrap">
                <table>
                    <thead>
                        <tr>
                            {item.table.head.map((h, i) => <th key={i}>{h}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {item.table.rows.map((row, i) => (
                            <tr key={i}>
                                {row.map((cell, j) => <td key={j}>{cell}</td>)}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
    return null;
}

export default function PrivacyPolicy() {
    const [lang, setLang] = React.useState(getInitialLang);
    const t = content[lang];

    function changeLang(l) {
        try { localStorage.setItem('publicLang', l); } catch (e) { /* ignore */ }
        setLang(l);
    }

    const navLinks = [
        { href: '/public/landing', label: t.nav.home },
        { href: '/public/mobile', label: t.nav.mobile },
        { href: '/public/privacy-policy', label: t.nav.privacy }
    ];

    return (
        <React.Fragment>
            <style>{`
                .privacy-page {
                    --bg: #080c14;
                    --navy: #141d2b;
                    --blue-light: #5aa1d8;
                    --text: #eaf1f8;
                    --muted: #8a97a9;
                    --card: rgba(255, 255, 255, 0.04);
                    --border: rgba(255, 255, 255, 0.08);
                    --radius: 18px;
                    font-family: 'Inter', system-ui, sans-serif;
                    color: var(--text);
                    background: var(--bg);
                    line-height: 1.7;
                    overflow-x: hidden;
                    min-height: 100vh;
                    position: relative;
                    -webkit-font-smoothing: auto;
                    -moz-osx-font-smoothing: auto;
                }
                .privacy-page * { margin: 0; padding: 0; box-sizing: border-box; font-family: 'Inter', system-ui, sans-serif; }
                .privacy-page::before {
                    content: ""; position: fixed; inset: 0; z-index: 0;
                    background:
                        radial-gradient(circle at 50% 35%, rgba(29, 110, 164, 0.28), transparent 55%),
                        radial-gradient(circle at 85% 80%, rgba(29, 110, 164, 0.18), transparent 50%),
                        var(--bg);
                }
                .privacy-page::after {
                    content: ""; position: fixed; inset: 0; z-index: 0;
                    background-image: radial-gradient(rgba(255,255,255,0.05) 1px, transparent 1px);
                    background-size: 26px 26px;
                    mask-image: radial-gradient(circle at 50% 40%, #000 30%, transparent 85%);
                    -webkit-mask-image: radial-gradient(circle at 50% 40%, #000 30%, transparent 85%);
                }
                .privacy-page main, .privacy-page footer { position: relative; z-index: 1; }
                .privacy-page .wrap { max-width: 1160px; margin: 0 auto; padding: 0 24px; }

                .privacy-page main.wrap { padding: 80px 24px 40px; }
                .privacy-page h1 { font-size: clamp(30px, 5vw, 44px); font-weight: 900; letter-spacing: -1px; margin-bottom: 14px; }
                .privacy-page .updated { color: var(--muted); font-size: 13px; margin-bottom: 22px; }
                .privacy-page .intro { color: var(--muted); font-size: 17px; margin-bottom: 14px; }

                .privacy-page section.block {
                    background: rgba(255, 255, 255, 0.06); border: 1px solid var(--border); border-radius: var(--radius);
                    padding: 24px 26px; margin-top: 18px;
                    transition: transform .2s, border-color .2s, background .2s;
                }
                .privacy-page section.block:hover { transform: translateY(-4px); border-color: rgba(90,161,216,.4); background: rgba(29,110,164,.08); }
                .privacy-page section.block h2 { font-size: 19px; font-weight: 700; color: var(--text); margin-bottom: 12px; }
                .privacy-page section.block h3 {
                    font-size: 15px; font-weight: 700; color: var(--blue-light);
                    margin: 20px 0 10px;
                }
                .privacy-page section.block h3:first-child { margin-top: 0; }
                .privacy-page section.block p { color: var(--muted); font-size: 15px; margin-bottom: 10px; }
                .privacy-page section.block p:last-child { margin-bottom: 0; }

                .privacy-page section.block ul { list-style: none; margin: 0 0 12px; padding: 0; }
                .privacy-page section.block ul:last-child { margin-bottom: 0; }
                .privacy-page section.block li {
                    color: var(--muted); font-size: 15px; position: relative;
                    padding-left: 18px; margin-bottom: 7px;
                }
                .privacy-page section.block li:last-child { margin-bottom: 0; }
                .privacy-page section.block li::before {
                    content: ""; position: absolute; left: 2px; top: 11px;
                    width: 5px; height: 5px; border-radius: 50%; background: var(--blue-light); opacity: .75;
                }

                .privacy-page .table-wrap { overflow-x: auto; margin: 0 0 12px; -webkit-overflow-scrolling: touch; }
                .privacy-page .table-wrap:last-child { margin-bottom: 0; }
                .privacy-page table {
                    width: 100%; border-collapse: collapse; min-width: 520px;
                    font-size: 14px; color: var(--muted);
                }
                .privacy-page thead th {
                    text-align: left; font-weight: 700; color: var(--text);
                    background: rgba(29,110,164,.18);
                    padding: 10px 12px; border-bottom: 1px solid var(--border); white-space: nowrap;
                }
                .privacy-page tbody td {
                    padding: 10px 12px; border-bottom: 1px solid var(--border); vertical-align: top;
                }
                .privacy-page tbody tr:last-child td { border-bottom: none; }
                .privacy-page tbody tr:hover td { background: rgba(255,255,255,.03); }

                .privacy-page footer { position: relative; z-index: 1; }

            `}</style>

            <div className="privacy-page">
                <PublicHeader
                    lang={lang}
                    onLangChange={changeLang}
                    links={navLinks}
                    loginLabel={t.nav.login}
                />

                <main className="wrap">
                    <h1>{t.docTitle}</h1>
                    <p className="updated">{t.lastUpdated}: {LAST_UPDATED[lang]}</p>
                    <p className="intro">{t.intro}</p>

                    {t.sections.map((section, i) => (
                        <section className="block" key={i}>
                            <h2>{section.title}</h2>
                            {section.body.map((item, j) => (
                                <Block key={j} item={item} />
                            ))}
                        </section>
                    ))}
                </main>

                <PublicFooter lang={lang} />
            </div>
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/views/Public/PrivacyPolicy/PrivacyPolicy.js